/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  userInfo: localStorage.getItem('userInfo') || null,
  accessToken: localStorage.getItem('accessToken') || '',
  
  isUserLoggedIn: () => {
      let isAuthenticated = false;
      const firebaseCurrentUser = firebase.auth().currentUser;
      // if (firebaseCurrentUser) {
      if (localStorage.getItem('accessToken')) {
        isAuthenticated = true;
      } else {
        isAuthenticated = false;
      }
      return (localStorage.getItem('userInfo') && isAuthenticated);
  },
  userRole: localStorage.getItem('userRole')
}